export default __webpack_public_path__ + "static/media/c4.2499d4c0.jpg";